export const environment = {
  production: false,

  authApiUrl: '/api/auth',
  dataApiUrl: '/api/data',
  customerApiUrl: '/api/customer',
  aiApiUrl: '/api/chat',
  ticketApiUrl: '/api/tickets',

  builderApiKey: 'fd4814467bb54a6da123213a976892e2'
};
